import React from 'react'
import { Link } from 'react-router-dom';

const BedSheet = () => {
    return (
        <>
            <div className="product-section">
                <div className="container">
                    <div className="row">

                        {/* Product 1 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet8.jpg" className="img-fluid product-thumbnail"  alt="Cotton Printed Bed Sheet" />
                                <h3 className="product-title">Fitted Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,299</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet9.jpg" className="img-fluid product-thumbnail"  alt="Cotton Printed Bed Sheet" />
                                <h3 className="product-title">Fitted Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,299</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet7.jpeg" className="img-fluid product-thumbnail"  alt="Cotton Printed Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,299</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet5.jpeg" className="img-fluid product-thumbnail" alt="Premium Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,899</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet6.jpeg" className="img-fluid product-thumbnail" alt="Premium Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,899</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 2 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet4.jpeg" className="img-fluid product-thumbnail" alt="Premium Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,899</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet2.jpeg" className="img-fluid product-thumbnail" alt="Floral King Size Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,499</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>

                        {/* Product 3 */}
                        <div className="col-12 col-md-4 col-lg-3 mb-5 mb-md-0">
                            <Link className="product-item" to="#">
                                <img src="/images/sheet1.jpeg" className="img-fluid product-thumbnail" alt="Premium Bed Sheet" />
                                <h3 className="product-title">Premium Bed Sheet</h3>
                                {/* <strong className="product-price">₹ 1,899</strong> */}
                                <span className="icon-cross"><img src="images/cross.svg" className="img-fluid" alt="add" /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BedSheet;
